import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { forwardRef, } from "react";
import { cn } from "../lib/cn.js";
// Faithful to the web `.btn-*` classes it replaces:
//   md  = btn-standard  · sm = btn-sm · lg = btn-md · xl = btn-lg
//   primary = solid · secondary = reverse · outline = hollow
const button = cva("block cursor-pointer rounded-full text-center font-medium transition-all duration-300 ease-in-out hover:scale-[1.02] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:scale-100", {
    variants: {
        variant: {
            primary: "bg-orange text-white hover:bg-orange/70",
            secondary: "bg-white text-orange hover:bg-white/70",
            outline: "border border-orange text-orange",
        },
        size: {
            sm: "px-4 py-[5px] text-display-11",
            md: "px-10 py-2 text-display-9",
            lg: "px-10 py-[10px] text-display-7",
            xl: "px-12 py-3 text-display-7",
        },
        fullWidth: {
            true: "w-full",
            false: "w-max",
        },
    },
    defaultVariants: {
        variant: "primary",
        size: "md",
        fullWidth: false,
    },
});
export const Button = forwardRef(function Button({ as, className, variant, size, fullWidth, ...props }, ref) {
    const Component = as || "button";
    return (_jsx(Component, { ...props, ref: ref, className: cn(button({ variant, size, fullWidth }), className) }));
});
